import styled from 'styled-components';

export const SolidColorIcon = styled.div`
  display: block;
  min-width: 2rem;
  height: 2rem;
  margin-right: 1rem;
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}px;
  background-color: ${({ $color }) => $color};
`;

export const ColorfulIcon = styled.div`
  display: block;
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}px;
  background-image: url('/static/img/colorful-filter.png');
  background-image: conic-gradient(
    rgb(255 0 0),
    rgb(255 0 255),
    rgb(0 0 255),
    rgb(0 255 255),
    rgb(0 255 0),
    rgb(255 255 0),
    rgb(255 0 0)
  );
  background-size: cover;
`;
